<template>
  <v-card flat class="ml-8 mr-8">
    <v-container class="ma-0">
      <v-row class="ma-0">
        <v-col cols="4">
          <v-img src="@/assets/speaker.png"></v-img>
        </v-col>
        <v-col cols="8">
          <v-card-title>{{ person.firstName + ' ' + person.lastName }}</v-card-title>
          <v-card-subtitle>{{ person.publicEmail }}</v-card-subtitle>
          <v-card-text>
            <strong>{{ speech.name }}</strong>
            <br>
            {{ speech.description }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>

  </v-card>
</template>

<script>
export default {
  name: 'SInfo',
  props: {
    person: {
      type: Object,
      required: true
    },
    speech: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
